<template>
    <the-detail-layout>
        <the-path-aside slot="aside"></the-path-aside>
        <the-path-header slot="header"></the-path-header>
        <the-path-body slot="body"></the-path-body>
        <the-detail-footer slot="footer"></the-detail-footer>
    </the-detail-layout>
</template>

<script>
import ThePathAside from './components/the-path-aside';
import ThePathBody from './components/the-path-body';
import TheDetailFooter from './components/the-detail-footer';
import ThePathHeader from './components/the-path-header';
import TheDetailLayout from './components/the-detail-layout';

export default {
    name: 'DocumentDetail',
    components: {
        TheDetailFooter,
        ThePathBody,
        ThePathHeader,
        ThePathAside,
        TheDetailLayout
    }
};
</script>
